
import React, { Component } from 'react'

class Loading extends Component {
  render () {
    return (
      <div style={{width: '100%', height: '500px', textAlign: 'center', paddingTop: '100px'}}>サーバからデータを取得中....</div>
    )
  }
}

export default Loading



// WEBPACK FOOTER //
// ./src/common/component/Loading.js